var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCeloSquareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    rx: 40,
    fill: "#FCFF52"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "black"
    },
    d: "M188.9,60.7H60.7v128.2h128.2v-44.8h-21.3c-7.3,16.3-23.8,27.7-42.7,27.7c-26,0-47.1-21.3-47.1-47.1c0-25.9,21.1-47,47.1-47 c19.3,0,35.8,11.7,43.1,28.4h20.9V60.7z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeloSquareLogo);
export default __webpack_public_path__ + "static/media/celo_square_logo.2ca4ce8b181980cb6ca8b5809319ec49.svg";
export { ForwardRef as ReactComponent };